export default __webpack_public_path__ + "5de789ef28d13ef0b6ba7126cd86d515.png";